import React, { useState, useEffect } from 'react'
import { Table, Flex } from 'antd';   
import { useKehuyhzhListQuery } from '../../store/DianShangYeWuApi';
import ClientBankAdd from './ClientBankAdd';
import classes from './client.module.css';
import ClientBankEdit from './ClientBankEdit';
function ClientBankList(props) {
    const [bankInfo, setBankInfo] = useState([])
    //客户银行
    const { data: bankData, isSuccess: bankSuccess } = useKehuyhzhListQuery({ khyhzh_kh_id: props.kh_id }, { skip: !props.kh_id, refetchOnMountOrArgChange: 1 })
    useEffect(() => {
        if (bankSuccess) {
            setBankInfo(bankData.Result)
        }
    }, [bankData, bankSuccess])
    const columnsBank = [
        {
            key:'khyhzh_name',
            title:'账户名称',
            dataIndex:'khyhzh_name',
            width: '15%',
            render: (text, record) => {
                return <ClientBankEdit 
                            qy_id={props.qy_id} 
                            qy_name={props.qy_name} 
                            kh_name={props.kh_name} 
                            kh_id={props.kh_id} 
                            yh_id={props.yh_id} 
                            yh_name={props.yh_name} 
                            khyhzh_id={record.khyhzh_id} 
                            khyhzh_name={record.khyhzh_name} 
                            khyhzh_bank={record.khyhzh_bank} 
                            khyhzh_code={record.khyhzh_code} 
                            khyhzh_content={record.khyhzh_content} 
                            khyhzh_ctime={record.khyhzh_ctime}
                            khyhzh_update_time={record.khyhzh_update_time}
                            khyhzh_cname={record.khyhzh_cname}
                            khyhzh_update_uname={record.khyhzh_update_uname}
                        />
            }
        },
        {
            key:'khyhzh_bank',
            title:'开户行',
            dataIndex:'khyhzh_bank',
            width: '15%',
        },
        {
            key:'khyhzh_code',
            title:'账号',
            dataIndex:'khyhzh_code',
            width: '15%',
        },
        {
            key:'khyhzh_content',
            title:'备注',
            dataIndex:'khyhzh_content',
            width: '15%',
        },      
    ]
    return (
            <>
                <Flex justify='space-between' align='center' style={{width:'1000px',marginTop:'20px'}}>
                    <div style={{fontSize:'16px',fontWeight:'bold',color:'#666600'}}>银行账户</div>
                    <ClientBankAdd kh_id={props.kh_id} yh_id={props.yh_id} yh_name={props.yh_name} />
                </Flex>

                <Table 
                    rowKey='khyhzh_id'
                    pagination={false}
                    className={classes.bankTable}
                    dataSource={bankInfo} 
                    columns={columnsBank} 
                    size='small'
                    bordered
                    style={{marginTop:'2px',width:'1000px'}}
                    locale={{
                        emptyText: '暂无银行账户' // This will display text when the table is empty
                    }}
                />
            </>
    )
}

export default ClientBankList